export default __webpack_public_path__ + "static/media/orange_innovate.8966be1c.png";